import {
  PageGen,
  PdfRect,
  PdfUnit,
  PdfBrush,
  PdfColor,
  PdfPen,
  PdfPoint,
  ETextAlign,
} from '../pdf/pdf';
import { GUtil } from '../pdf/gutil';
import { IColorSchema } from './colorSchema';

export class ColorSchemaFormal implements IColorSchema {
  readonly name = 'Formal';

  private sizeTopHeader = PdfUnit.FromMillimeters(10);
  private marginAround = PdfUnit.FromMillimeters(1);
  private marginTopContent = PdfUnit.FromMillimeters(4);
  private teacherNotesWidth = PdfUnit.FromMillimeters(25);
  private borderThickness = 0.8;

  drawPage(page: PageGen, rect: PdfRect, inner: PdfRect, pageNumber: number): void {
    const bottomRect = new PdfRect(0, inner.bottom, rect.width, rect.height - inner.bottom);
    page.drawString(
      `Page ${pageNumber}`,
      GUtil.exerciseFont,
      PdfBrush.Black,
      null,
      bottomRect,
      ETextAlign.Center
    );
  }

  drawWindow(page: PageGen, rect: PdfRect, _index: number, counter?: string, title?: string): void {
    const font = GUtil.exerciseFont;
    const pen = new PdfPen(PdfColor.fromRgb(0, 0, 0), this.borderThickness);

    // Main window border
    page.drawRectangle(pen, null, rect);

    // Header division
    const headerRect = new PdfRect(rect.x, rect.y, rect.width, this.sizeTopHeader);

    // 1. Exercise Number Square
    const counterWidth = this.sizeTopHeader;
    const rCounter = new PdfRect(headerRect.x, headerRect.y, counterWidth, headerRect.height);
    page.drawRectangle(pen, PdfBrush.White, rCounter);
    if (counter) {
      page.drawString(counter, font, PdfBrush.Black, null, rCounter, ETextAlign.Center);
    }

    // 2. Teacher Notes Rectangle (at the end)
    const rNotes = new PdfRect(
      headerRect.right - this.teacherNotesWidth,
      headerRect.y,
      this.teacherNotesWidth,
      headerRect.height
    );
    page.drawRectangle(pen, null, rNotes);

    // 3. Title/Header (middle part)
    const rTitle = new PdfRect(
      rCounter.right,
      headerRect.y,
      rNotes.left - rCounter.right,
      headerRect.height
    );
    page.drawRectangle(pen, null, rTitle);
    if (title) {
      page.drawString(
        title,
        font,
        PdfBrush.Black,
        null,
        rTitle.deflate(PdfUnit.FromMillimeters(2)),
        ETextAlign.CenterLeft
      );
    }
  }

  drawResult(page: PageGen, rect: PdfRect): void {
    const pen = new PdfPen(PdfColor.fromRgb(0, 0, 0), 0.5);
    page.drawLine(pen, new PdfPoint(rect.left, rect.bottom), new PdfPoint(rect.right, rect.bottom));
  }

  calcContent(rect: PdfRect): PdfRect {
    return new PdfRect(
      rect.x + this.marginAround,
      rect.y + this.sizeTopHeader + this.marginTopContent,
      rect.width - 2 * this.marginAround,
      rect.height - this.sizeTopHeader - this.marginTopContent - this.marginAround
    );
  }
}
